/**
 * Rider Status Constants
 * 라이더 현황 페이지 관련 상수 정의
 */

// ===========================================
// 1. 계약 상태 상수
// ===========================================

export const CONTRACT_STATUS = {
    UNDER_CONTRACT: 'UNDER_CONTRACT',
    TERMINATED_CONTRACT: 'TERMINATED_CONTRACT',
    CONTRACT_PENDING: 'CONTRACT_PENDING'
} as const;

export type ContractStatus = typeof CONTRACT_STATUS[keyof typeof CONTRACT_STATUS];

export const CONTRACT_STATUS_LABELS: Record<ContractStatus, string> = {
    [CONTRACT_STATUS.UNDER_CONTRACT]: '계약중',
    [CONTRACT_STATUS.TERMINATED_CONTRACT]: '계약종료',
    [CONTRACT_STATUS.CONTRACT_PENDING]: '계약대기',
};

export const CONTRACT_STATUS_OPTIONS = [
    { value: '', label: '전체' },
    { value: CONTRACT_STATUS.UNDER_CONTRACT, label: CONTRACT_STATUS_LABELS[CONTRACT_STATUS.UNDER_CONTRACT] },
    { value: CONTRACT_STATUS.TERMINATED_CONTRACT, label: CONTRACT_STATUS_LABELS[CONTRACT_STATUS.TERMINATED_CONTRACT] },
] as const;

// ===========================================
// 2. 페이지네이션 상수
// ===========================================

export const ITEMS_PER_PAGE = {
    DEFAULT: 10,
    LARGE: 15,
    EXTRA_LARGE: 20,
} as const;

// ===========================================
// 3. 스토리지 키 상수
// ===========================================

export const STORAGE_KEYS = {
    /** 라이더 현황 필터 */
    RIDER_STATUS_FILTERS: 'riderStatusFilters',
} as const;

export type StorageKey = typeof STORAGE_KEYS[keyof typeof STORAGE_KEYS];

// ===========================================
// 4. 활성 라이더 상태 (공지 대상 필터링용)
// ===========================================

export const ACTIVE_RIDER_STATUSES = ['운영 중', '계약 중'];
